import { Dialog, DialogContent } from '@/components/ui/Dialog';
import { useAuth } from '@/context/AuthContext';
import { useEffect, useState } from 'react';
import { Button } from './Button/Button';

const ComModal = () => {
  const [showComModal, setShowComModal] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    // Only show modal on anara.so or localhost domains
    const hostname = window.location.hostname;
    if (hostname === 'anara.so') {
      setShowComModal(true);
    }
  }, []);

  const handleRedirect = () => {
    window.location.href = 'https://anara.com/login';
  };

  return (
    <Dialog
      modal={true}
      open={showComModal}
      onOpenChange={() => {
        // Do nothing - prevents closing
      }}
    >
      <DialogContent
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        hideCloseButton={true}
        className="w-[90%] max-w-md px-6 py-5"
      >
        <div className="flex flex-col gap-6 ">
          <div className="flex flex-col gap-3">
            <h2 className="text-lg font-semibold">We've moved to anara.com</h2>
            <p className="text-sm text-muted-foreground">
              You need to log back in to continue using Anara. You are currently
              logged in as:
            </p>
            {user?.email && (
              <div className="flex items-center gap-2 p-3 bg-muted rounded-md">
                <div className="h-2 w-2 rounded-full bg-blue-500" />
                <span className="text-sm font-medium">{user.email}</span>
              </div>
            )}
          </div>

          <Button onClick={handleRedirect} className="w-full mt-2">
            Continue to Login
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ComModal;
